import React from "react";
import { Helmet } from "react-helmet-async";
import { SITE } from "./categories";

export default function MetaTags({ title, description, image, type = "website", url, schema }) {
  const fullTitle = title ? `${title} | ${SITE.name}` : SITE.name;
  const desc = description || SITE.description;
  const img = image || "https://images.pexels.com/photos/20649748/pexels-photo-20649748.jpeg";
  const fullUrl = url || (typeof window !== "undefined" ? window.location.href : SITE.url);
  const schemas = schema ? (Array.isArray(schema) ? schema.filter(Boolean) : [schema]) : [];

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={img} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:site_name" content={SITE.name} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
      {schemas.map((s, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(s)}</script>
      ))}
    </Helmet>
  );
}
